import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Connection lifecycle + transient UI states this card renders. Mirrors the shared
 * `ConnectionStatus` vocabulary plus the in-flight `idle`/`loading` UI states. Kept
 * as a local string union so the card stays vendor-agnostic (no Bexio/companies-fe
 * coupling): the Annual Report import drives it for BOTH Bexio and D365 BC.
 */
export type IntegrationSyncCardStatus = 'idle' | 'loading' | 'connected' | 'expired' | 'error';

/**
 * Catalog/sync card used in the Annual Report import step. Shows a vendor banner,
 * name + description, and a single state-driven action (connect / reconnect / sync).
 * In `syncMode` it renders the last-sync hint and a "sync data" button instead of
 * a disconnect button. Vendor-agnostic: the host wires status + handlers per vendor.
 */
@Component({
    selector: 'aumico-integration-sync-card',
    templateUrl: 'integration-sync-card.component.html',
    styleUrls: ['integration-sync-card.component.scss'],
})
export class IntegrationSyncCardComponent {
    @Input() name = '';
    @Input() description = '';
    @Input() logoSrc = '';
    @Input() logoClass = '';
    @Input() bannerBgColor = '#f3f4f6';
    @Input() connectionStatus: IntegrationSyncCardStatus = 'idle';
    @Input() syncMode = false;
    @Input() lastSyncAt: string | Date | null = null;
    @Input() noMatchingYear = false;

    @Output() connectClicked = new EventEmitter<void>();
    @Output() disconnectClicked = new EventEmitter<void>();
    @Output() syncDataClicked = new EventEmitter<void>();

    public get isConnected(): boolean {
        return this.connectionStatus === 'connected';
    }

    public get isExpired(): boolean {
        return this.connectionStatus === 'expired';
    }

    public get isLoading(): boolean {
        return this.connectionStatus === 'loading';
    }
}
